
import * as types from './mutation-types'

export default {

  ADD_CLIENTS: function (state, clients) {
    state.contacts = clients;
    localStorage.contacts = JSON.stringify(state.contacts);
  },
  ADD_CLIENT: function(state, client) {
    let clientExist = state.contacts.find(x => x.id === client.id);
    if (!clientExist) {
      state.contacts.push(client);
      localStorage.contacts = JSON.stringify(state.contacts);
    }
  },

      [types.ADD_CONTACTS](state, data) {
    state.contacts = data.contacts
  },
  [types.ADD_CONTACT](state, data) {
    state.contacts.push(data)
  },
  SET_ONLY_CLIENT_ID: function(state, id){
    state.clientId = id
  },

  SET_CLIENT_ID: function (state, {id, sellerId, cart}) {
    //if(id) this.dispatch('contact/getClientFidelity', id);
    state.clientId = id
    let carts = JSON.parse(localStorage.getItem('carts' + sellerId))
    if(carts) {
      let currentCart = carts[cart]
      currentCart.clientId = id
      carts = {...carts, [cart]: currentCart}
      localStorage.setItem('carts' + sellerId, JSON.stringify(carts))
    }

  },

  RESET_CONTACT: function (state) {
    state.clientId = null
  },

  SET_COUNTRIES: function(state, countries){
    state.countries = countries
  },

  SET_CLIENT_FIDELITY: function(state, {fidelity, clientId}){
    return state.contacts.forEach(contact =>{
      if(contact.id === clientId){
        contact.fidelity = fidelity
      }
    })
  },

  SET_CITIES: function(state, cities){
    state.cities = cities
  },

  SET_STATES: function(state, states){
    state.states = states
  },

  SET_STREETS: function(state, streets){
    state.streets = streets
  }


}
